enum FeatureFlag {
  GenerateReports = "generate_reports",
}

export default FeatureFlag;
